import { FC } from "react"
import useWindowDimensions from "../../core/hooks/useWindowDimensions"

interface XTitleProps {
  children: any
  size?: string
  top?: number
  bottom?: number
  style?: any
  maxWidth?: string
}

const XTitle: FC<XTitleProps> = ({
  children, style = {}, size = "default", top = 30, bottom = 16, maxWidth = "unset"
}) => {
  const { width } = useWindowDimensions()
  return (
    <>
      <h1 style={{
        fontFamily: "Farm",
        fontSize: size == "default" ? (width > 960 ? "78px" : "48px") : (size == "small" ? "48px" : size),
        fontWeight: "700",
        lineHeight: "1",
        marginTop: `${top}px`,
        marginBottom: `${width > 960 ? bottom : bottom / 2}px`,
        color: "#000",
        maxWidth: width > 960 ? maxWidth : "",
        ...style
      }}>{children}</h1>
    </>
  )
}

export default XTitle